import mcq from './mcq';
import "./question.css"
export default mcq;


// WEBPACK FOOTER //
// /src/call/container/mcq/index.js